import { MapLayer } from '../../layers/components/MapLayer'
import { useDrawArea } from './useDrawArea'

export function DrawArea() {
  useDrawArea()

  return <MapLayer uid="draw" />
}
